import React, { memo } from 'react';
import cn from 'clsx';
import { ThemeProvider } from 'fronton-react';
import { StickyPanel } from '../../../sticky-panel';
import {
  fixedMobilePanel,
  fixedMobilePanelWithWhiteBack,
  hiddenMobilePanel,
  mobileFixedPanelCreator,
  mobilePanel,
} from './mobile-fixed-panel-creator-styles';
import { MobileFixedPanel, MobileFixedPanelStructure, PanelActionBlock } from '../mobile-fixed-panel';
import { TabletFixedPanel } from '../tablet-fixed-panel';

type MobileFixedPanelCreatorProps = {
  isConsultationFormVisible: boolean | undefined;
  withWhiteBackground: boolean | undefined;
  tabletActionBloc: PanelActionBlock[];
  structure: MobileFixedPanelStructure;
};

export const MobileFixedPanelCreator = memo(
  ({
    isConsultationFormVisible,
    withWhiteBackground,
    tabletActionBloc,
    structure,
  }: MobileFixedPanelCreatorProps) => (
    <ThemeProvider>
      <StickyPanel
        alwaysOnTop={false}
        className={cn(mobilePanel, mobileFixedPanelCreator, {
          [hiddenMobilePanel]: isConsultationFormVisible,
        })}
        fixedClassName={cn(fixedMobilePanel, {
          [fixedMobilePanelWithWhiteBack]: withWhiteBackground,
        })}
        renderContent={() => (
          <>
            <TabletFixedPanel actionBlock={tabletActionBloc} />
            <MobileFixedPanel structure={structure} />
          </>
        )}
      />
    </ThemeProvider>
  )
);
